import React, { useEffect, useState } from 'react';
import { Alert, Checkbox, Flex, Form, Input, Modal, Segmented, Steps, Typography } from 'antd';
import mcc from './MainContainerComponents.module.scss';
import theme from '../../utils/themes/Themes.module.scss';

import Link from 'next/link';
import { IModalProps, IRegisterProps } from 'tkmp-lib/src/interfaces';
import {
    EInnStatus,
    EPopupNotificationType,
    EProfileType,
    ERegisterStatus,
    ERegisterType,
} from 'tkmp-lib/src/enums';
import { AuthService } from 'tkmp-lib/src/services/AuthService';
import { ValidateService } from 'tkmp-lib/src/services/ValidateService';
import { observer } from 'mobx-react-lite';
import { usePopup } from 'tkmp-lib/src/hooks/usePopup';
import { Button } from 'antd';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';
import SpinBlock from '../SpinBlock/SpinBlock';

// @ts-ignore
const ModalRegistrationForm = observer(({ callback_open, callback_close }: IModalProps) => {
    const LOCALIZATION = useLocalization();
    const [form] = Form.useForm();
    const [isWaitingResponse, setIsWaitingResponse] = useState<boolean>(false);
    const { notification } = usePopup();
    const [checkboxFirst, setCheckboxFirst] = useState<boolean>(false);
    const [checkboxSecond, setCheckboxSecond] = useState<boolean>(false);

    const [isPending, setIsPending] = useState<boolean>(false);

    const [registerBody, setRegisterBody] = useState<IRegisterProps>({
        profile_type: ERegisterType.Buyer,
        profile_fio: '',
        profile_phone: '',
        profile_email: '',
        organisation_inn: '',
        organisation_name: '',
        organisation_address: '',
        isAgreePersonalData: false,
        isAgreePlatformRules: false,
    });

    const callback_submit = (values: any) => {
        if (process.env.NEXT_PUBLIC_DEBUG === 'true') console.log(values);

        setRegisterBody((prevState) => ({ ...prevState, ...values }));
        if (currentStep === 0) setCurrentStep(1);
        else if (currentStep === 1) setCurrentStep(2);

        return;
    };

    const [registerType, setRegisterType] = useState<ERegisterType>(ERegisterType.Buyer);

    const perform_close = () => {
        callback_close();
        setIsWaitingResponse(false);
        form.resetFields();
        setCurrentStep(0);
    };

    const [innStatus, setInnStatus] = useState(EInnStatus.Unknown);
    const [currentStep, setCurrentStep] = useState<number>(0);

    useEffect(() => {
        if (currentStep === 2) {
            if (process.env.NEXT_PUBLIC_DEBUG === 'true') console.log(registerBody);
            setIsWaitingResponse(true);

            const result = {
                profile_type: registerBody.profile_type,
                profile_fio: registerBody.profile_fio,
                profile_phone: registerBody.profile_phone,
                profile_email: registerBody.profile_email,
                organisation_inn: registerBody.organisation_inn,
                organisation_address: registerBody.organisation_address,
                organisation_name: registerBody.organisation_name,
            };

            AuthService.register(result).then((answer: any) => {
                setIsPending(false);
                switch (answer.saved as ERegisterStatus) {
                    case ERegisterStatus.Success:
                        if (answer.send) {
                            notification.success({
                                message:
                                    LOCALIZATION.modals.register.notification.answerSendSuccess
                                        .message,
                                description:
                                    LOCALIZATION.modals.register.notification.answerSendSuccess
                                        .description,
                            });
                        } else {
                            notification.success({
                                message:
                                    LOCALIZATION.modals.register.notification.notAnswerSendSuccess
                                        .message,
                                description:
                                    LOCALIZATION.modals.register.notification.notAnswerSendSuccess
                                        .description,
                            });
                        }
                        break;
                    case ERegisterStatus.Bad:
                        notification.error({
                            message:
                                LOCALIZATION.modals.register.notification.errorStatusBad.message,
                            description: `${LOCALIZATION.modals.register.notification.errorStatusBad.description} (${answer.value})`,
                        });
                        break;
                    case ERegisterStatus.Failed:
                        notification.error({
                            message:
                                LOCALIZATION.modals.register.notification.errorStatusFailed.message,
                            description:
                                LOCALIZATION.modals.register.notification.errorStatusFailed
                                    .description,
                        });
                        break;
                }
                perform_close();
            });
        }
    }, [currentStep, registerBody]);

    const [inn, setInn] = useState('');

    const onInnChange = (value: string) => {
        setInn(value);
    };

    useEffect(() => {
        setInnStatus(ValidateService.Inn(inn));
    }, [inn]);

    useEffect(() => {
        if (process.env.NEXT_PUBLIC_DEBUG === 'true') console.log(innStatus);
    }, [innStatus]);

    const steps = [
        {
            title: LOCALIZATION.modals.register.stepFirst,
        },
        {
            title: LOCALIZATION.modals.register.stepSecond,
        },
    ];

    // @ts-ignore
    return (
        <Modal
            className={`${theme.GeneralContainer__Theme} ${mcc.modal}`}
            centered
            open={callback_open}
            onCancel={perform_close}
            width={1064}
            okButtonProps={{
                style: { display: 'none' },
            }}
            cancelButtonProps={{
                style: { display: 'none' },
            }}
        >
            <Flex
                gap={'large'}
                vertical
                className={mcc.registerBlock}
                align={'center'}
                justify={'center'}
            >
                <Typography.Text className={`text-32-500`}>
                    {LOCALIZATION.modals.register.title}
                </Typography.Text>
                <Alert
                    className={mcc.registerMessage}
                    message={`${LOCALIZATION.modals.register.alertTailStart} ${registerType === ERegisterType.Manufacturer ? LOCALIZATION.modals.register.alertTargetFirst : LOCALIZATION.modals.register.alertTargetSecond}${LOCALIZATION.modals.register.alertTailEnd}`}
                />
                <Steps
                    current={currentStep}
                    style={{ width: '343px' }}
                    size={'small'}
                    items={steps}
                />
                {currentStep === 0 && (
                    <Form
                        name={'firstStepRegister'}
                        form={form}
                        onFinish={(values) => callback_submit(values)}
                        layout={'vertical'}
                        style={{ width: '100%' }}
                        disabled={currentStep >= 2}
                        initialValues={registerBody}
                    >
                        <Flex vertical>
                            <Form.Item
                                className={mcc.formItem}
                                layout="vertical"
                                label={LOCALIZATION.modals.register.form.organisation_inn.title}
                                name="organisation_inn"
                                rules={[
                                    {
                                        required: true,
                                        // message:
                                        //     LOCALIZATION.modals.register.form.organisation_inn
                                        //         .errorMessage,
                                    },
                                ]}
                                validateStatus={innStatus}
                                help={
                                    innStatus === EInnStatus.Error &&
                                    LOCALIZATION.modals.register.form.organisation_inn.errorMessage
                                }
                            >
                                <Input
                                    value={inn}
                                    onChange={(e) => setInn(e.target.value)}
                                    placeholder={
                                        LOCALIZATION.modals.register.form.organisation_inn
                                            .placeholder
                                    }
                                />
                            </Form.Item>
                            <Form.Item
                                className={mcc.formItem}
                                layout="vertical"
                                label={LOCALIZATION.modals.register.form.organisation_name.title}
                                name="organisation_name"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            LOCALIZATION.modals.register.form.organisation_name
                                                .errorMessage,
                                    },
                                ]}
                            >
                                <Input
                                    placeholder={
                                        LOCALIZATION.modals.register.form.organisation_name
                                            .placeholder
                                    }
                                />
                            </Form.Item>
                            <Form.Item
                                className={mcc.formItem}
                                layout="vertical"
                                label={LOCALIZATION.modals.register.form.organisation_address.title}
                                name="organisation_address"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            LOCALIZATION.modals.register.form.organisation_address
                                                .errorMessage,
                                    },
                                ]}
                            >
                                <Input placeholder={'https://example.ru'} />
                            </Form.Item>
                        </Flex>
                        <Flex gap={'small'}>
                            <Button
                                htmlType={'submit'}
                                size={'large'}
                            >
                                {LOCALIZATION.modals.register.form.buttons.next}
                            </Button>
                        </Flex>
                    </Form>
                )}
                {currentStep >= 1 && (
                    <Form
                        name={'secondStepRegister'}
                        form={form}
                        onFinish={(values) => callback_submit(values)}
                        layout={'vertical'}
                        disabled={currentStep >= 2}
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px',
                            position: 'relative',
                        }}
                    >
                        {isWaitingResponse && <SpinBlock />}
                        <Flex>
                            <Form.Item
                                name={'profile_type'}
                                style={{ width: '100%' }}
                            >
                                <Segmented
                                    style={{ width: '100%' }}
                                    block
                                    size={'large'}
                                    options={[
                                        {
                                            label: LOCALIZATION.modals.register.form.profile_type
                                                .values.buyer,
                                            value: EProfileType.Buyer,
                                        },
                                        {
                                            label: LOCALIZATION.modals.register.form.profile_type
                                                .values.manufacturer,
                                            value: EProfileType.Manufacturer,
                                        },
                                        // {
                                        //     label: LOCALIZATION.modals.register.form.profile_type
                                        //         .values.tradingCompany,
                                        //     value: EProfileType.Distributer,
                                        // },
                                    ]}
                                />
                            </Form.Item>
                        </Flex>
                        <Flex vertical>
                            <Form.Item
                                className={mcc.formItem}
                                layout="vertical"
                                label={LOCALIZATION.modals.register.form.profile_fio.title}
                                name="profile_fio"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            LOCALIZATION.modals.register.form.profile_fio
                                                .errorMessage,
                                    },
                                ]}
                            >
                                <Input
                                    placeholder={
                                        LOCALIZATION.modals.register.form.profile_fio.placeholder
                                    }
                                />
                            </Form.Item>
                            <Form.Item
                                className={mcc.formItem}
                                layout="vertical"
                                label={LOCALIZATION.modals.register.form.profile_phone.title}
                                name="profile_phone"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            LOCALIZATION.modals.register.form.profile_phone
                                                .errorMessage,
                                    },
                                ]}
                            >
                                <Input
                                    placeholder={
                                        LOCALIZATION.modals.register.form.profile_phone.placeholder
                                    }
                                />
                            </Form.Item>
                            <Form.Item
                                className={mcc.formItem}
                                layout="vertical"
                                label={LOCALIZATION.modals.register.form.profile_email.title}
                                name="profile_email"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            LOCALIZATION.modals.register.form.profile_email
                                                .errorMessage,
                                    },
                                ]}
                            >
                                <Input
                                    placeholder={
                                        LOCALIZATION.modals.register.form.profile_email.placeholder
                                    }
                                />
                            </Form.Item>
                        </Flex>
                        <Flex vertical>
                            <Flex
                                gap={'small'}
                                align={'flex-start'}
                            >
                                <Form.Item
                                    name={'isAgreePersonalData'}
                                    rules={[
                                        {
                                            validator: (_, value) =>
                                                value
                                                    ? Promise.resolve()
                                                    : Promise.reject(
                                                          new Error(
                                                              'Для работы с платформой необходимо принять условия',
                                                          ),
                                                      ),
                                        },
                                    ]}
                                    noStyle
                                    valuePropName="checked"
                                >
                                    <Checkbox>
                                        {
                                            LOCALIZATION.modals.register.form.isAgreePersonalData
                                                .title
                                        }{' '}
                                        <Link href={'./'}>
                                            {
                                                LOCALIZATION.modals.register.form
                                                    .isAgreePersonalData.linkTitle
                                            }
                                        </Link>
                                    </Checkbox>
                                </Form.Item>
                            </Flex>
                            <Flex
                                gap={'small'}
                                align={'flex-start'}
                            >
                                <Form.Item
                                    name={'isAgreePlatformRules'}
                                    rules={[
                                        {
                                            validator: (_, value) =>
                                                value
                                                    ? Promise.resolve()
                                                    : Promise.reject(
                                                          new Error(
                                                              'Для работы с платформой необходимо принять условия',
                                                          ),
                                                      ),
                                        },
                                    ]}
                                    noStyle
                                    valuePropName="checked"
                                >
                                    <Checkbox>
                                        {
                                            LOCALIZATION.modals.register.form.isAgreePlatformRules
                                                .title
                                        }
                                        <Link href={'./'}>
                                            {
                                                LOCALIZATION.modals.register.form
                                                    .isAgreePlatformRules.linkTitle
                                            }
                                        </Link>
                                    </Checkbox>
                                </Form.Item>
                            </Flex>
                        </Flex>
                        <Flex gap={'small'}>
                            <Button
                                size={'large'}
                                ghost
                                onClick={() => setCurrentStep((prevState) => prevState - 1)}
                            >
                                {LOCALIZATION.modals.register.form.buttons.back}
                            </Button>
                            <Button
                                size={'large'}
                                htmlType={'submit'}
                                loading={isPending}
                                disabled={!(!checkboxFirst || !checkboxSecond) && isPending}
                            >
                                {LOCALIZATION.modals.register.form.buttons.submit}
                            </Button>
                        </Flex>
                    </Form>
                )}
            </Flex>
        </Modal>
    );
});

export default ModalRegistrationForm;
